// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';


import { maintenanceOperationGroupApi } from '../lib/api';
import { SET_MAINTENANCE_OPERATION_GROUPS } from './maintenanceOperationGroups';

export const SET_MAINTENANCE_OPERATION_GROUP =
'vehicles/maintenance-operation-group/set';
const CLEAR_MAINTENANCE_OPERATION_GROUP =
'vehicles/maintenance-operation-group/clear';

const initialState = null;

export const replaceMaintenanceOperationGroupInTree = (
node,
maintenanceOperationGroup) =>
{
  let currentNode = { ...node };
  if (node.id === maintenanceOperationGroup.id) {
    currentNode = {
      ...currentNode,
      ...maintenanceOperationGroup
    };
  }
  let children = currentNode.children ? [...currentNode.children] : [];
  children = children.map(
    (child) =>
    replaceMaintenanceOperationGroupInTree(child, maintenanceOperationGroup)
  );
  return {
    ...currentNode,
    children: children.length ? children : []
  };
};

const addMaintenanceOperationGroupToTree = (
node,
parentId,
maintenanceOperationGroup) =>
{
  let children = node.children ? [...node.children] : [];
  children = children.map((child) =>
  addMaintenanceOperationGroupToTree(
    child,
    parentId,
    maintenanceOperationGroup
  )
  );
  if (node.id === parentId) {
    children = [...children, maintenanceOperationGroup];
  }
  return {
    ...node,
    children: children.length ? children : null
  };
};

const removeFromTree = (
node,
maintenanceOperationGroupId) =>
{
  let children = node.children ? [...node.children] : [];
  children = children.
  filter((child) => child.id !== maintenanceOperationGroupId).
  map((child) => removeFromTree(child, maintenanceOperationGroupId));
  return {
    ...node,
    children: children.length ? children : null
  };
};

const setMaintenanceOperationGroupAction = createAction(
  SET_MAINTENANCE_OPERATION_GROUP
);
const clearMaintenanceOperationGroupAction = createAction(
  CLEAR_MAINTENANCE_OPERATION_GROUP
);
const setMaintenanceOperationGroupsAction = createAction(
  SET_MAINTENANCE_OPERATION_GROUPS
);

const maintenanceOperationGroupSlice = createSlice({
  name: 'maintenanceOperationGroup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(setMaintenanceOperationGroupAction, (state, { payload }) => payload).
    addCase(clearMaintenanceOperationGroupAction, () => initialState);
  }
});

export const maintenanceOperationGroupActions = {
  set: setMaintenanceOperationGroupAction,
  clear: clearMaintenanceOperationGroupAction
};

export const clear = () => (dispatch) =>
dispatch(maintenanceOperationGroupActions.clear());

export const addMaintenanceOperationGroup = (
maintenanceOperationGroup,
parentId) =>
async (
dispatch,
getState) =>
{
  const addedMaintenanceOperationGroup = await maintenanceOperationGroupApi.addMaintenanceOperationGroup(
    {
      ...maintenanceOperationGroup,
      parentId
    }
  );
  const state = getState();
  const addedMaintenanceOperationGroups = addMaintenanceOperationGroupToTree(
    state.maintenanceOperationGroups,
    parentId,
    addedMaintenanceOperationGroup
  );
  dispatch(setMaintenanceOperationGroupsAction(addedMaintenanceOperationGroups));
};

export const updateMaintenanceOperationGroup = (
orgUnit) =>
async (
dispatch,
getState) =>
{
  const updatedMaintenanceOperationGroup = await maintenanceOperationGroupApi.updateMaintenanceOperationGroup(
    orgUnit
  );
  const state = getState();
  const maintenanceOperationGroups = replaceMaintenanceOperationGroupInTree(
    state.maintenanceOperationGroups,
    updatedMaintenanceOperationGroup
  );
  dispatch(setMaintenanceOperationGroupsAction(maintenanceOperationGroups));
};

export const deleteMaintenanceOperationGroup = (
id) =>
async (
dispatch,
getState) =>
{
  await maintenanceOperationGroupApi.deleteMaintenanceOperationGroup(id);
  const state = getState();
  const maintenanceOperationGroup = removeFromTree(
    state.maintenanceOperationGroups,
    id
  );
  dispatch(setMaintenanceOperationGroupsAction(maintenanceOperationGroup));
};

export const fetchMaintenanceOperationGroup = (
id) =>
async (dispatch) => {
  const maintenanceOperationGroup = await maintenanceOperationGroupApi.fetchMaintenanceOperationGroup(
    id
  );
  dispatch(maintenanceOperationGroupActions.set(maintenanceOperationGroup));
};

export default maintenanceOperationGroupSlice.reducer;
